import { auth, storage } from "../config/firebase.config";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import {
  postUploadNewImageMedia,
  postUploadNewVideoMedia,
} from "../service/Media.service";
import { useEffect, useState } from "react";
import { CONST } from "../consts/consts";
import useToastContext from "./useToastContext.hook";
import Routes from "../routers/Routes.router.json";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import NeoSpinner from "../design/design_components/neo/overlay/NeoSpinner.base";
import { v4 as uuidv4 } from "uuid";

export default function useUploadMedia() {
  const userId = auth.currentUser.uid;
  const toast = useToastContext();
  const [response, setResponse] = useState(null);
  const history = useHistory();

  function delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  const uploadImage = async (file, filename = "") => {
    let path = `neowifi/media/image/${userId}/${uuidv4()}_${
      filename ? filename : file.name
    }`;
    const fileRef = ref(storage, path);

    const snapshot = await uploadBytes(fileRef, file);
    const url = await getDownloadURL(fileRef);

    return {
      fileRef: fileRef,
      url: url,
    };
  };

  const updateImage = async (file, oldFileUrl, fileName = "") => {
    try {
      const refDelete = ref(storage, oldFileUrl);
      await deleteObject(refDelete);
    } catch (error) {
      console.error("Error deleting old image", error);
    }

    return await uploadImage(file, fileName);
  };

  const uploadUncompressedVideoMedia = async (file, metaData) => {
    let path = `neowifi/media/video/${userId}/${new Date().valueOf()}_${
      file.name
    }`;
    const fileRef = ref(storage, path);
    uploadBytes(fileRef, file).then((snapshot) => {
      getDownloadURL(fileRef).then((url) => {
        uploadVideoToStorage({
          videoURL: url,
          metaData: metaData,
        }).then((result) => {
          if (result.success) {
            toast.setMessage(
              CONST.SEVERITY.SUCCESS,
              CONST.TOAST_MESSAGES.SUCCESS_TO_UPDATE.HEADLINE,
              CONST.TOAST_MESSAGES.SUCCESS_TO_UPDATE.DETAILS
            );
            history.push(Routes.media.home);
          } else {
            toast.setMessage(
              CONST.SEVERITY.ERROR,
              CONST.TOAST_MESSAGES.DATA_DOES_NOT_LOAD.HEADLINE,
              CONST.TOAST_MESSAGES.DATA_DOES_NOT_LOAD.DETAILS
            );

            delay(2000).then((e) => {
              history.go(0);
            });
          }
        });
      });
    });
  };

  const updateUncompressedVideoMedia = async (file, metaData, refDelete) => {
    await deleteObject(refDelete);
    let path = `neowifi/media/video/${userId}/${new Date().valueOf()}_${
      file.name
    }`;
    const fileRef = ref(storage, path);
    uploadBytes(fileRef, file).then((snapshot) => {
      getDownloadURL(fileRef).then((url) => {
        uploadVideoToStorage({
          videoURL: url,
          metaData: metaData,
        }).then((result) => {
          if (result.success) {
            toast.setMessage(
              CONST.SEVERITY.SUCCESS,
              CONST.TOAST_MESSAGES.SUCCESS_TO_UPDATE.HEADLINE,
              CONST.TOAST_MESSAGES.SUCCESS_TO_UPDATE.DETAILS
            );
            history.push(Routes.media.home);
          } else {
            toast.setMessage(
              CONST.SEVERITY.ERROR,
              CONST.TOAST_MESSAGES.DATA_DOES_NOT_LOAD.HEADLINE,
              CONST.TOAST_MESSAGES.DATA_DOES_NOT_LOAD.DETAILS
            );

            delay(2000).then((e) => {
              history.go(0);
            });
          }
        });
      });
    });
  };

  const uploadImageToStorage = async (data) => {
    let result = await postUploadNewImageMedia(data);
    setResponse(result);
    return result;
  };

  const uploadVideoToStorage = async (data) => {
    let result = await postUploadNewVideoMedia(data);
    setResponse(result);
    return result;
  };

  return {
    uploadImage,
    uploadImageToStorage,
    uploadUncompressedVideoMedia,
    updateImage,
    updateUncompressedVideoMedia,
    response,
  };
}
